import React, { Component } from "react";
import Slider from "@mui/material/Slider";
import { Box, FormControl, MenuItem, Select, Switch } from "@mui/material";
import Header from "../header";

class CarFiltering extends Component {
  getFilterValue = (filterId) => {
    const value = this.props.features.find(
      (feature) => feature.id === filterId,
    );
    return value?.value || "";
  };

  render() {
    const {
      filter,
      changePriceRange,
      handleStock,
      stock,
      applyFilter,
      price,
      handleModal,
      clearFilter,
      checkForNumric,
      checkForText,
      defaultPrice,
      addFilter,
      brands,
      models,
      types,
      cars,
      handleCarType,
      handleCarModel,
      handleCarBrand,
    } = this.props;
    return (
      <>
        <div className="carFiltering">
          <Header
            showSearchBar={true}
            title="فیلتر بندی"
            backHandler={() => handleModal()}
          />
          <div className="carFilterSections">
            <div className="carFilterBox">
              {filter?.map((filter, index) =>
                filter?.type === 2 ? (
                  <Box key={index}>
                    <label>{filter?.feature}</label>
                    <FormControl>
                      <Select
                        value={this.getFilterValue(filter?.id)}
                        onChange={(e) => addFilter(filter?.id, e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="">مهم نیست</MenuItem>

                        {filter?.list.map((filter, index) => (
                          <MenuItem value={filter} key={index}>
                            {filter}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                ) : (
                  <div className="filterInput">
                    <label>{filter?.feature}</label>
                    <input
                      type="text"
                      placeholder="مهم نیست"
                      onChange={
                        filter?.type === 1
                          ? (e) => checkForNumric(filter?.id, e.target.value)
                          : (e) => checkForText(filter?.id, e.target.value)
                      }
                    />
                  </div>
                ),
              )}
              <div className="inputSection">
                <Box sx={{ minWidth: 120 }}>
                  <label>برند</label>

                  <FormControl>
                    <Select
                      displayEmpty
                      name="brands"
                      label="برند خودرو"
                      value={brands}
                      inputProps={{ "aria-label": "Without label" }}
                      onChange={handleCarBrand}
                    >
                      <MenuItem disabled value="" className="addCarPlaceHolder">
                        برند خودرو
                      </MenuItem>
                      {cars?.map((car, index) => (
                        <MenuItem key={index} value={car}>
                          {car.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="inputSection">
                <Box sx={{ minWidth: 120 }}>
                  <label>مدل</label>

                  <FormControl>
                    <Select
                      displayEmpty
                      disabled={!brands}
                      name="models"
                      value={models}
                      inputProps={{ "aria-label": "Without label" }}
                      onChange={handleCarModel}
                    >
                      <MenuItem disabled value="" className="addCarPlaceHolder">
                        مدل خودرو
                      </MenuItem>

                      {brands
                        ? brands.cars?.map((brand, index) => (
                            <MenuItem key={index} value={brand}>
                              {brand.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
              </div>

              <div className="inputSection">
                <Box sx={{ minWidth: 120 }}>
                  <label>تیپ</label>

                  <FormControl>
                    <Select
                      displayEmpty
                      disabled={!models}
                      name="types"
                      value={types}
                      inputProps={{ "aria-label": "Without label" }}
                      onChange={handleCarType}
                    >
                      <MenuItem disabled value="" className="addCarPlaceHolder">
                        تیپ
                      </MenuItem>

                      {models
                        ? models.types.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
            <div className="carFilterSliderBox">
              <label>قیمت</label>
              <Slider
                min={defaultPrice[0]}
                max={defaultPrice[1]}
                onChange={changePriceRange}
                value={[price[0], price[1]]}
                className="priceRangeSlider"
              />

              <div className="priceRangeNum">
                <span>{price[1]?.toLocaleString()} تومان</span>
                <span>{price[0]?.toLocaleString()} تومان</span>
              </div>
            </div>
            <div className="carFilterBox">
              <div className="carFilterSwitch">
                <label>اجناس موجود</label>
                <Switch
                  value={stock}
                  onChange={handleStock}
                  className="filterSwitch"
                  color="default"
                />
              </div>
            </div>
            <div className="carFilterBtnSection">
              <button
                className="carFilterClearBtn"
                onClick={() => {
                  clearFilter();
                }}
              >
                حذف فیلتر
              </button>
              <button
                className="carFilterBtn"
                onClick={() => {
                  applyFilter();
                }}
              >
                اعمال فیلتر
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CarFiltering;
